import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  _Any: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
};

export type Artist = {
  __typename?: 'Artist';
  analyticsCode?: Maybe<Scalars['String']['output']>;
  artistId: Scalars['String']['output'];
  avatarUrl: Scalars['String']['output'];
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  established: Scalars['Boolean']['output'];
  externalSites: Array<ArtistExternalSite>;
  fanArtist: Scalars['Boolean']['output'];
  featuredArtist: Scalars['Boolean']['output'];
  followerCount?: Maybe<Scalars['Int']['output']>;
  followingCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use artistId */
  id: Scalars['ID']['output'];
  joinedDate: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  shopUrl?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type ArtistExternalSite = {
  __typename?: 'ArtistExternalSite';
  label: Scalars['String']['output'];
  site: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Generic nested key value type. Extremely deprecated. Cleanse any usage with fire. */
export type Attribute = {
  __typename?: 'Attribute';
  /** @deprecated Use the PTR */
  attributes: Array<Attribute>;
  /** @deprecated Use the PTR */
  name: Scalars['String']['output'];
  /** @deprecated Use the PTR */
  value: Scalars['Any']['output'];
};

/** Deprecated: see ProductFamily. */
export type CategorySet = {
  __typename?: 'CategorySet';
  /** @deprecated Use publicName */
  categoryName: Scalars['String']['output'];
  configurationSet: Array<Attribute>;
  defaultItem: ProductSetItem;
  defaultItems: Array<ProductSetItem>;
  id: Scalars['ID']['output'];
  items: Array<ProductSetItem>;
  /** @deprecated Use the PTR. ProductFamily.publicName or ProductType.publicName. */
  publicName: Scalars['String']['output'];
  work: Work;
};


/** Deprecated: see ProductFamily. */
export type CategorySetWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** A size guide table */
export type DimensionGuide = {
  __typename?: 'DimensionGuide';
  columns: Array<Attribute>;
  fixedFirstColumn: Scalars['Boolean']['output'];
  rows: Array<Attribute>;
};

/** Product dimensions */
export type Dimensions = {
  __typename?: 'Dimensions';
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  unit: Unit;
  width: Scalars['Float']['output'];
};

export type InStockStatus = StockStatus & {
  __typename?: 'InStockStatus';
  /** Always 'in-stock' */
  status: Scalars['String']['output'];
};

/** A single inventory item */
export type InventoryItem = {
  __typename?: 'InventoryItem';
  /** @deprecated Use the PTR: ProductFamily.options, ProductType.options, BlankItem.options */
  attributes: Array<Attribute>;
  blankItemId: Scalars['String']['output'];
  /** @deprecated Use ProductType.copy.publicName in PTR */
  description: Scalars['String']['output'];
  /** @deprecated Use ProductType.copy.features in PTR */
  features: Array<Scalars['String']['output']>;
  /** @deprecated Use the PTR: productType.sizing != null */
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use ProductType.copy.longDescription in PTR */
  longStyleDescription: Scalars['String']['output'];
  /** See InventoryItemsItem.measurementSummary for details */
  measurementSummary?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Preview>;
  previewSet?: Maybe<PreviewSet>;
  price?: Maybe<Price>;
  /** @deprecated Use ProductType.copy.features in PTR */
  productInfo: ProductInfo;
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<ProductUrl>;
  productTypeId: Scalars['String']['output'];
  /**
   * stockStatus will always be "in stock" if country is not passed. This is for
   * backward compatibility reasons: clients that are not yet configured to send
   * the shipping country can't suddenly find everything is out of stock.
   */
  stockStatus: StockStatus;
  volumeDiscount?: Maybe<VolumeDiscount>;
  work: Work;
  workId: Scalars['Int']['output'];
};


/** A single inventory item */
export type InventoryItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/** A single inventory item */
export type InventoryItemPreviewSetArgs = {
  previewTypeIds: Array<Scalars['String']['input']>;
};


/** A single inventory item */
export type InventoryItemPriceArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
};


/** A single inventory item */
export type InventoryItemProductPageUrlArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


/** A single inventory item */
export type InventoryItemProductPageUrlsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


/** A single inventory item */
export type InventoryItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryItems = {
  __typename?: 'InventoryItems';
  items: Array<InventoryItemsItem>;
};

/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type InventoryItemsItem = {
  __typename?: 'InventoryItemsItem';
  /** @deprecated Use the PTR: ProductFamily.options, ProductType.options, BlankItem.options */
  attributes: Array<Attribute>;
  blankItemId: Scalars['String']['output'];
  /** @deprecated Use ProductType.copy.publicName in PTR */
  description: Scalars['String']['output'];
  /** @deprecated Use ProductType.copy.features in PTR */
  features: Array<Scalars['String']['output']>;
  /** @deprecated Use the PTR: productType.sizing != null */
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use ProductType.copy.longDescription in PTR */
  longStyleDescription: Scalars['String']['output'];
  /**
   * Measurement summaries are short textual descriptions of the dimensions of an inventory item,
   * accounting for the dimensions of the users work if the product is variably sized.
   *
   * Summaries will only appear if they are enabled in PTR for this particular product type.
   * Not every product has this set. It is wise to also check the PTR yourself, just in
   * case we change this in future (likely).
   *
   * The field that governs this in PTR is 'ProductType.sizing.attachMeasurementSummaryToAttribute'
   * (misnamed, "Attribute" should be "Option").
   */
  measurementSummary?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Preview>;
  previewSet?: Maybe<PreviewSet>;
  price?: Maybe<Price>;
  /** @deprecated Use ProductType.copy.features in PTR */
  productInfo: ProductInfo;
  /**
   * productPageUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<ProductUrl>;
  productTypeId: Scalars['String']['output'];
  /** See InventoryItem.stockStatus for caveats */
  stockStatus: StockStatus;
  volumeDiscount?: Maybe<VolumeDiscount>;
  work: Work;
  workId: Scalars['Int']['output'];
};


/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type InventoryItemsItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type InventoryItemsItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type NoopEntityToWorkAroundFederationBug = {
  __typename?: 'NoopEntityToWorkAroundFederationBug';
  id: Scalars['ID']['output'];
};

export type OutOfStockStatus = StockStatus & {
  __typename?: 'OutOfStockStatus';
  /** Always 'out-of-stock' */
  status: Scalars['String']['output'];
};

export type PresaleStockStatus = StockStatus & {
  __typename?: 'PresaleStockStatus';
  /** Always 'presale' */
  status: Scalars['String']['output'];
};

/** A preview with its preview type ID and Magickraum URL */
export type Preview = {
  __typename?: 'Preview';
  /**
   * All available formats for this preview (image/jpeg, image/webp). There
   *   should be one and only one format marked as default. The default format in
   *   this list will also be available as 'url' and 'mime' in the Preview type.
   */
  formats: Array<PreviewFormat>;
  id: Scalars['ID']['output'];
  /** Mime type of the fallback format from formats */
  mime: Scalars['String']['output'];
  previewTypeId: Scalars['String']['output'];
  /** URL of the fallback format from formats */
  url: Scalars['String']['output'];
};

export type PreviewFormat = {
  __typename?: 'PreviewFormat';
  fallback: Scalars['Boolean']['output'];
  mime: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A wrapper for one or more Previews to annotate with inventory item id */
export type PreviewItem = {
  __typename?: 'PreviewItem';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['ID']['output'];
  item: Array<Preview>;
};

/** Set of previews with urls */
export type PreviewSet = {
  __typename?: 'PreviewSet';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['ID']['output'];
  previews: Array<Preview>;
};

/** Represents a price with currency */
export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  discount: PromoDiscount;
  id: Scalars['ID']['output'];
};

export type ProductFamily = {
  __typename?: 'ProductFamily';
  /** @deprecated Use publicName */
  categoryName: Scalars['String']['output'];
  /** @deprecated Use the PTR */
  configurationSet: Array<Attribute>;
  defaultItem: InventoryItemsItem;
  defaultItems: Array<InventoryItemsItem>;
  id: Scalars['ID']['output'];
  items: Array<InventoryItemsItem>;
  /** @deprecated Use the PTR. ProductFamily.publicName or ProductType.publicName. */
  publicName: Scalars['String']['output'];
  work: Work;
};


export type ProductFamilyWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Wrapper type for product description */
export type ProductInfo = {
  __typename?: 'ProductInfo';
  /** @deprecated Use ProductType.copy.features in PTR */
  longDescription: Array<Scalars['String']['output']>;
};

export type ProductPageUrls = {
  __typename?: 'ProductPageUrls';
  /**
   * fallbackUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  fallbackUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * url is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * A single inventory item contained within a CategorySet
 *
 * Severely deprecated. Remove once the deprecated CategorySet type is removed.
 */
export type ProductSetItem = {
  __typename?: 'ProductSetItem';
  /** @deprecated Use the PTR: ProductFamily.options, ProductType.options, BlankItem.options */
  attributes: Array<Attribute>;
  blankItemId: Scalars['String']['output'];
  /** @deprecated Use ProductType.copy.publicName in PTR */
  description: Scalars['String']['output'];
  /** @deprecated Use ProductType.copy.features in PTR */
  features: Array<Scalars['String']['output']>;
  /** @deprecated Use the PTR: productType.sizing != null */
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use ProductType.copy.longDescription in PTR */
  longStyleDescription: Scalars['String']['output'];
  /** See InventoryItemsItem.measurementSummary for details */
  measurementSummary?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Preview>;
  previewSet?: Maybe<PreviewSet>;
  price?: Maybe<Price>;
  /** @deprecated Use ProductType.copy.features in PTR */
  productInfo: ProductInfo;
  /**
   * productPageUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<ProductPageUrls>;
  productTypeId: Scalars['String']['output'];
  /** See InventoryItem.stockStatus for caveats */
  stockStatus: StockStatus;
  volumeDiscount?: Maybe<VolumeDiscount>;
  work: Work;
  workId: Scalars['Int']['output'];
};


/**
 * A single inventory item contained within a CategorySet
 *
 * Severely deprecated. Remove once the deprecated CategorySet type is removed.
 */
export type ProductSetItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A single inventory item contained within a CategorySet
 *
 * Severely deprecated. Remove once the deprecated CategorySet type is removed.
 */
export type ProductSetItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** A Product URL */
export type ProductUrl = {
  __typename?: 'ProductUrl';
  /**
   * fallbackUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'url' field.
   */
  fallbackUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * url is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients EXCEPT under the following circumstances:
   *
   * - To add (but not remove or modify) individual query string parameters. For example,
   *   if the IHS returns the URL '/foo/bar/?fleeb=derb', you may change it to
   *   '/foo/bar/?fleeb=derb&utm_thingy=1&other=yep', but you may not change it to
   *   '/foo/bar/?fleeb=quarg', as that modifies an existing param you have been sent.
   * - To add a fragment _iff_ the client knows itself to be the target of the URL AND
   *   there is no fragment already
   * - To modify the authority _iff_ the client knows itself to be the target of the URL
   *   (this would likely be envronment specific, and this rule is mostly intended for
   *   facilitating local development)
   *
   * All other parts of the URL, in all other circumstances, should be left exactly as
   * they are received.
   */
  url?: Maybe<Scalars['String']['output']>;
};

/** A wrapper for one or more Product URLs to annotate with inventory item id */
export type ProductUrlItem = {
  __typename?: 'ProductUrlItem';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['String']['output'];
  item: ProductUrl;
  locale?: Maybe<Scalars['String']['output']>;
};

/** Represents a promotional discount of a price */
export type PromoDiscount = {
  __typename?: 'PromoDiscount';
  amount: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
};

/** The query root of this schema */
export type Query = {
  __typename?: 'Query';
  _entities: Array<Maybe<_Entity>>;
  _service: _Service;
  /**
   * Catalogue of inventory items and available configuration options for the given category and work
   * @deprecated Use productFamily
   */
  categorySet?: Maybe<CategorySet>;
  /** @deprecated Use findDefaultInventoryItems */
  defaultInventoryItems?: Maybe<Array<Maybe<InventoryItemsItem>>>;
  /** @deprecated Use findDefaultInventoryItems */
  defaultInventoryItemsForWorks: Array<InventoryItemsItem>;
  /** Dimensions for Inventory Item ID */
  dimension?: Maybe<Dimensions>;
  /**
   * Find default inventory items for the given categories and work.
   *
   * If productTypeIds is null, you will receive all productTypeIds for a work.
   * If productTypeIds is empty, you will receive an empty list.
   */
  findDefaultInventoryItems: InventoryItems;
  /**
   * Find default inventory items for the given categories and multiple works.
   *
   * If productTypeIds is null, you will receive all productTypeIds for the works.
   * If productTypeIds is empty, you will receive an empty list.
   *
   * Note that it can be hazardous to send too many workIds without any
   * productTypeIds; you may run afoul of timeouts.
   */
  findDefaultInventoryItemsForWorks: InventoryItems;
  findInventoryItems: InventoryItems;
  /** @deprecated Use findInventoryItems */
  inventoryItem?: Maybe<InventoryItem>;
  /** @deprecated Use findInventoryItems */
  inventoryItems?: Maybe<Array<Maybe<InventoryItemsItem>>>;
  /** Product url lookup for Inventory Item IDs returning all localised variants */
  localisedProductUrls: Array<ProductUrlItem>;
  /** Default preview lookup for Inventory Item ID or search by Preview Type ID */
  preview?: Maybe<Preview>;
  /** Default preview lookup for Inventory Item ID or search by Preview Type ID */
  previews: Array<PreviewItem>;
  /** Catalogue of inventory items for the given product family and work */
  productFamily?: Maybe<ProductFamily>;
  /** Default product url lookup for Inventory Item ID, locale, and group ID */
  productUrl?: Maybe<ProductUrl>;
  /** Default product url lookup for Inventory Item IDs, local, and group ID */
  productUrls: Array<ProductUrlItem>;
  /**
   * Size guide table for the given product type ID by locale.
   * Does not support category/family IDs. Work ID is required.
   *
   * inventoryItemId has no effect other than to be validated, and may be deprecated. The
   * product type in inventoryItemId MUST match productTypeId, the work ID in inventoryItemID
   * MUST match workId.
   */
  sizeGuide?: Maybe<DimensionGuide>;
  works: Array<Work>;
};


/** The query root of this schema */
export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']['input']>;
};


/** The query root of this schema */
export type QueryCategorySetArgs = {
  categoryId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds: Array<Scalars['String']['input']>;
  unit: Unit;
  workId: Scalars['Int']['input'];
};


/** The query root of this schema */
export type QueryDefaultInventoryItemsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit: Unit;
  workId: Scalars['Int']['input'];
};


/** The query root of this schema */
export type QueryDefaultInventoryItemsForWorksArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit: Unit;
  workIds: Array<Scalars['Int']['input']>;
};


/** The query root of this schema */
export type QueryDimensionArgs = {
  inventoryItemId: Scalars['String']['input'];
  unit: Unit;
};


/** The query root of this schema */
export type QueryFindDefaultInventoryItemsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit: Unit;
  workId: Scalars['Int']['input'];
};


/** The query root of this schema */
export type QueryFindDefaultInventoryItemsForWorksArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit: Unit;
  workIds: Array<Scalars['Int']['input']>;
};


/** The query root of this schema */
export type QueryFindInventoryItemsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit: Unit;
};


/** The query root of this schema */
export type QueryInventoryItemArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  unit: Unit;
};


/** The query root of this schema */
export type QueryInventoryItemsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit: Unit;
};


/** The query root of this schema */
export type QueryLocalisedProductUrlsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  inventoryItemIds: Array<Scalars['ID']['input']>;
  strict?: Scalars['Boolean']['input'];
};


/** The query root of this schema */
export type QueryPreviewArgs = {
  inventoryItemId: Scalars['ID']['input'];
  previewTypeId?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type QueryPreviewsArgs = {
  inventoryItemIds: Array<Scalars['ID']['input']>;
  previewTypeIds: Array<Scalars['ID']['input']>;
};


/** The query root of this schema */
export type QueryProductFamilyArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds: Array<Scalars['String']['input']>;
  productFamilyIdOrProductTypeId: Scalars['String']['input'];
  unit: Unit;
  workId: Scalars['Int']['input'];
};


/** The query root of this schema */
export type QueryProductUrlArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  inventoryItemId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
};


/** The query root of this schema */
export type QueryProductUrlsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  inventoryItemIds: Array<Scalars['ID']['input']>;
  locale: Scalars['String']['input'];
};


/** The query root of this schema */
export type QuerySizeGuideArgs = {
  inventoryItemId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
  workId: Scalars['Int']['input'];
};


/** The query root of this schema */
export type QueryWorksArgs = {
  locale: Scalars['String']['input'];
  workIds: Array<Scalars['Int']['input']>;
};

/**
 * XXX 20250805: We are leaving space for individual stock statuses to have their own
 * sets of fields. This is not in use at the time of writing, but we want to make sure
 * the option is available. Consuming systems MUST NOT close this door. Fields may be
 * added at the interface level, or the type level.
 */
export type StockStatus = {
  status: Scalars['String']['output'];
};

export enum Unit {
  Cm = 'CM',
  In = 'IN'
}

export type VolumeDiscount = {
  __typename?: 'VolumeDiscount';
  id: Scalars['ID']['output'];
  thresholds: Array<VolumeDiscountThreshold>;
};

export type VolumeDiscountThreshold = {
  __typename?: 'VolumeDiscountThreshold';
  percentOff: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type Work = {
  __typename?: 'Work';
  artist?: Maybe<Artist>;
  artistDisplayName: Scalars['String']['output'];
  artistShopDisplayName?: Maybe<Scalars['String']['output']>;
  artistUsername: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use workId */
  id: Scalars['ID']['output'];
  isMachineTranslated: Scalars['Boolean']['output'];
  licensed: Scalars['Boolean']['output'];
  linkBackTags: Array<Scalars['String']['output']>;
  matureContent: Scalars['Boolean']['output'];
  originalLocale?: Maybe<Scalars['String']['output']>;
  portfolioPreview?: Maybe<Preview>;
  productPageIndexable: Scalars['Boolean']['output'];
  /**
   * remoteKey contains the imagehaus image ID for either the :print image type, or
   *   a fallback image type. It has been used for constructing certain previews in the
   *   past, but see the deprecation notice for more details and please do not use it in
   *   future.
   * @deprecated This should not be used, especially not for constructing magickraum URLs by
   * hand; the Preview Reference API contained herein should perform that role. If
   * it does not satisfy a particular use case or it is not available at the point
   * in the graph you require, instead of using this, please reach out.
   */
  remoteKey?: Maybe<Scalars['String']['output']>;
  /** 'tags' is deprecated; use tagsOriginal or tagsCleaned */
  tags: Array<Scalars['String']['output']>;
  /** 'tagsCleaned' contains normalised tags, stripped of product synonyms */
  tagsCleaned: Array<Scalars['String']['output']>;
  /** 'tagsOriginal' contains the exact unmodified tags array we received from the monolith */
  tagsOriginal: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  workId: Scalars['Int']['output'];
};

export type _Entity = NoopEntityToWorkAroundFederationBug;

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type InventoryItemFragment = { __typename?: 'InventoryItemsItem', id: string, blankItemId: string, description: string, productTypeId: string, productPageUrl?: string | null, workId: number, work: { __typename?: 'Work', id: string, title: string, matureContent: boolean, tags: Array<string>, workId: number, licensed: boolean, isMachineTranslated: boolean, productPageIndexable: boolean, description?: string | null, url: string, linkBackTags: Array<string>, originalLocale?: string | null, artist?: { __typename?: 'Artist', artistId: string, displayName: string, username: string, profileUrl?: string | null, shopUrl?: string | null, avatarUrl: string, coverImageUrl?: string | null, location?: string | null, joinedDate: string, followerCount?: number | null, followingCount?: number | null, analyticsCode?: string | null, established: boolean, fanArtist: boolean, featuredArtist: boolean, externalSites: Array<{ __typename?: 'ArtistExternalSite', site: string, label: string, url: string }> } | null, portfolioPreview?: { __typename?: 'Preview', id: string, previewTypeId: string, url: string, mime: string, formats: Array<{ __typename?: 'PreviewFormat', mime: string, url: string, fallback: boolean }> } | null }, productPageUrls?: { __typename?: 'ProductUrl', url?: string | null, fallbackUrl: string } | null, previewSet?: { __typename?: 'PreviewSet', id: string, previews: Array<{ __typename?: 'Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
    | { __typename?: 'InStockStatus', status: string }
    | { __typename?: 'OutOfStockStatus', status: string }
    | { __typename?: 'PresaleStockStatus', status: string }
  , attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> };

export type SearchResultInventoryItemFragment = { __typename?: 'InventoryItemsItem', id: string, blankItemId: string, description: string, measurementSummary?: string | null, productTypeId: string, productPageUrl?: string | null, workId: number, work: { __typename?: 'Work', id: string, title: string, artistShopDisplayName?: string | null, artistUsername: string, matureContent: boolean, tags: Array<string> }, productPageUrls?: { __typename?: 'ProductUrl', url?: string | null, fallbackUrl: string } | null, previewSet?: { __typename?: 'PreviewSet', id: string, previews: Array<{ __typename?: 'Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
    | { __typename?: 'InStockStatus', status: string }
    | { __typename?: 'OutOfStockStatus', status: string }
    | { __typename?: 'PresaleStockStatus', status: string }
  , attributes: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> }> };

export type HomePageInventoryItemFragment = { __typename?: 'InventoryItemsItem', id: string, productTypeId: string, blankItemId: string, workId: number, description: string, productPageUrl?: string | null, preview?: { __typename?: 'Preview', url: string } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', quantity: number, percentOff: number }> } | null, stockStatus:
    | { __typename?: 'InStockStatus', status: string }
    | { __typename?: 'OutOfStockStatus', status: string }
    | { __typename?: 'PresaleStockStatus', status: string }
  , productPageUrls?: { __typename?: 'ProductUrl', url?: string | null, fallbackUrl: string } | null, work: { __typename?: 'Work', id: string, title: string, matureContent: boolean, artistShopDisplayName?: string | null, artistUsername: string, artist?: { __typename?: 'Artist', artistId: string } | null } };

export type SimilarDesignInventoryItemFragment = { __typename?: 'InventoryItemsItem', id: string, blankItemId: string, description: string, productTypeId: string, productPageUrl?: string | null, workId: number, previewSet?: { __typename?: 'PreviewSet', previews: Array<{ __typename?: 'Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
    | { __typename?: 'InStockStatus', status: string }
    | { __typename?: 'OutOfStockStatus', status: string }
    | { __typename?: 'PresaleStockStatus', status: string }
  , work: { __typename?: 'Work', id: string, url: string, title: string, matureContent: boolean, artistUsername: string, artistShopDisplayName?: string | null, portfolioPreview?: { __typename?: 'Preview', url: string } | null } };

export type GetCategorySetQueryVariables = Exact<{
  workId: Scalars['Int']['input'];
  categoryId: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  unit: Unit;
}>;


export type GetCategorySetQuery = { __typename?: 'Query', categorySet?: { __typename?: 'CategorySet', id: string, defaultItem: { __typename?: 'ProductSetItem', id: string }, work: { __typename?: 'Work', id: string, artistUsername: string } } | null };

export type ProductFamilyDefaultItemFragment = { __typename?: 'InventoryItemsItem', id: string, productTypeId: string, blankItemId: string };

export type ProductFamilyItemFragment = { __typename?: 'InventoryItemsItem', id: string, workId: number, productTypeId: string, blankItemId: string, description: string, measurementSummary?: string | null, hasSizeGuide: boolean, productPageUrl?: string | null, attributes: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> }>, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, previewSet?: { __typename?: 'PreviewSet', id: string, inventoryItemId: string, previews: Array<{ __typename?: 'Preview', id: string, previewTypeId: string, url: string, mime: string, formats: Array<{ __typename?: 'PreviewFormat', url: string, mime: string, fallback: boolean }> }> } | null, productPageUrls?: { __typename?: 'ProductUrl', id: string, url?: string | null, fallbackUrl: string } | null, stockStatus:
    | { __typename?: 'InStockStatus', status: string }
    | { __typename?: 'OutOfStockStatus', status: string }
    | { __typename?: 'PresaleStockStatus', status: string }
  , volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null };

export type ProductFamilyWorkFragment = { __typename?: 'Work', id: string, workId: number, matureContent: boolean, licensed: boolean, isMachineTranslated: boolean, productPageIndexable: boolean, artistUsername: string, artistDisplayName: string, artistShopDisplayName?: string | null, title: string, description?: string | null, url: string, linkBackTags: Array<string>, tags: Array<string>, tagsCleaned: Array<string>, tagsOriginal: Array<string>, originalLocale?: string | null, remoteKey?: string | null, artist?: { __typename?: 'Artist', artistId: string, displayName: string, username: string, avatarUrl: string, profileUrl?: string | null, established: boolean, featuredArtist: boolean, fanArtist: boolean, externalSites: Array<{ __typename?: 'ArtistExternalSite', label: string, site: string, url: string }> } | null, portfolioPreview?: { __typename?: 'Preview', id: string, previewTypeId: string, url: string, mime: string, formats: Array<{ __typename?: 'PreviewFormat', mime: string, url: string, fallback: boolean }> } | null };

export type GetProductFamilyQueryVariables = Exact<{
  workId: Scalars['Int']['input'];
  productFamilyIdOrProductTypeId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  unit: Unit;
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductFamilyQuery = { __typename?: 'Query', productFamily?: { __typename?: 'ProductFamily', id: string, categoryName: string, configurationSet: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> }>, defaultItem: { __typename?: 'InventoryItemsItem', id: string, productTypeId: string, blankItemId: string }, defaultItems: Array<{ __typename?: 'InventoryItemsItem', id: string, productTypeId: string, blankItemId: string }>, items: Array<{ __typename?: 'InventoryItemsItem', id: string, workId: number, productTypeId: string, blankItemId: string, description: string, measurementSummary?: string | null, hasSizeGuide: boolean, productPageUrl?: string | null, attributes: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> }>, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, previewSet?: { __typename?: 'PreviewSet', id: string, inventoryItemId: string, previews: Array<{ __typename?: 'Preview', id: string, previewTypeId: string, url: string, mime: string, formats: Array<{ __typename?: 'PreviewFormat', url: string, mime: string, fallback: boolean }> }> } | null, productPageUrls?: { __typename?: 'ProductUrl', id: string, url?: string | null, fallbackUrl: string } | null, stockStatus:
        | { __typename?: 'InStockStatus', status: string }
        | { __typename?: 'OutOfStockStatus', status: string }
        | { __typename?: 'PresaleStockStatus', status: string }
      , volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null }>, work: { __typename?: 'Work', id: string, workId: number, matureContent: boolean, licensed: boolean, isMachineTranslated: boolean, productPageIndexable: boolean, artistUsername: string, artistDisplayName: string, artistShopDisplayName?: string | null, title: string, description?: string | null, url: string, linkBackTags: Array<string>, tags: Array<string>, tagsCleaned: Array<string>, tagsOriginal: Array<string>, originalLocale?: string | null, remoteKey?: string | null, artist?: { __typename?: 'Artist', artistId: string, displayName: string, username: string, avatarUrl: string, profileUrl?: string | null, established: boolean, featuredArtist: boolean, fanArtist: boolean, externalSites: Array<{ __typename?: 'ArtistExternalSite', label: string, site: string, url: string }> } | null, portfolioPreview?: { __typename?: 'Preview', id: string, previewTypeId: string, url: string, mime: string, formats: Array<{ __typename?: 'PreviewFormat', mime: string, url: string, fallback: boolean }> } | null } } | null };

export type GetInventoryItemsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  unit: Unit;
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInventoryItemsQuery = { __typename?: 'Query', inventoryItems?: Array<{ __typename?: 'InventoryItemsItem', id: string, blankItemId: string, description: string, productTypeId: string, productPageUrl?: string | null, workId: number, work: { __typename?: 'Work', id: string, title: string, matureContent: boolean, tags: Array<string>, workId: number, licensed: boolean, isMachineTranslated: boolean, productPageIndexable: boolean, description?: string | null, url: string, linkBackTags: Array<string>, originalLocale?: string | null, artist?: { __typename?: 'Artist', artistId: string, displayName: string, username: string, profileUrl?: string | null, shopUrl?: string | null, avatarUrl: string, coverImageUrl?: string | null, location?: string | null, joinedDate: string, followerCount?: number | null, followingCount?: number | null, analyticsCode?: string | null, established: boolean, fanArtist: boolean, featuredArtist: boolean, externalSites: Array<{ __typename?: 'ArtistExternalSite', site: string, label: string, url: string }> } | null, portfolioPreview?: { __typename?: 'Preview', id: string, previewTypeId: string, url: string, mime: string, formats: Array<{ __typename?: 'PreviewFormat', mime: string, url: string, fallback: boolean }> } | null }, productPageUrls?: { __typename?: 'ProductUrl', url?: string | null, fallbackUrl: string } | null, previewSet?: { __typename?: 'PreviewSet', id: string, previews: Array<{ __typename?: 'Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
      | { __typename?: 'InStockStatus', status: string }
      | { __typename?: 'OutOfStockStatus', status: string }
      | { __typename?: 'PresaleStockStatus', status: string }
    , attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> } | null> | null };

export type GetDefaultInventoryItemsQueryVariables = Exact<{
  workId: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  productTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  unit: Unit;
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDefaultInventoryItemsQuery = { __typename?: 'Query', defaultInventoryItems?: Array<{ __typename?: 'InventoryItemsItem', id: string, blankItemId: string, description: string, productTypeId: string, productPageUrl?: string | null, workId: number, work: { __typename?: 'Work', id: string, title: string, matureContent: boolean, tags: Array<string>, workId: number, licensed: boolean, isMachineTranslated: boolean, productPageIndexable: boolean, description?: string | null, url: string, linkBackTags: Array<string>, originalLocale?: string | null, artist?: { __typename?: 'Artist', artistId: string, displayName: string, username: string, profileUrl?: string | null, shopUrl?: string | null, avatarUrl: string, coverImageUrl?: string | null, location?: string | null, joinedDate: string, followerCount?: number | null, followingCount?: number | null, analyticsCode?: string | null, established: boolean, fanArtist: boolean, featuredArtist: boolean, externalSites: Array<{ __typename?: 'ArtistExternalSite', site: string, label: string, url: string }> } | null, portfolioPreview?: { __typename?: 'Preview', id: string, previewTypeId: string, url: string, mime: string, formats: Array<{ __typename?: 'PreviewFormat', mime: string, url: string, fallback: boolean }> } | null }, productPageUrls?: { __typename?: 'ProductUrl', url?: string | null, fallbackUrl: string } | null, previewSet?: { __typename?: 'PreviewSet', id: string, previews: Array<{ __typename?: 'Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
      | { __typename?: 'InStockStatus', status: string }
      | { __typename?: 'OutOfStockStatus', status: string }
      | { __typename?: 'PresaleStockStatus', status: string }
    , attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> } | null> | null };

export type GetSearchResultInventoryItemsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  unit: Unit;
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSearchResultInventoryItemsQuery = { __typename?: 'Query', inventoryItems?: Array<{ __typename?: 'InventoryItemsItem', id: string, blankItemId: string, description: string, measurementSummary?: string | null, productTypeId: string, productPageUrl?: string | null, workId: number, work: { __typename?: 'Work', id: string, title: string, artistShopDisplayName?: string | null, artistUsername: string, matureContent: boolean, tags: Array<string> }, productPageUrls?: { __typename?: 'ProductUrl', url?: string | null, fallbackUrl: string } | null, previewSet?: { __typename?: 'PreviewSet', id: string, previews: Array<{ __typename?: 'Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
      | { __typename?: 'InStockStatus', status: string }
      | { __typename?: 'OutOfStockStatus', status: string }
      | { __typename?: 'PresaleStockStatus', status: string }
    , attributes: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> }> } | null> | null };

export type GetHomePageInventoryItemsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  unit: Unit;
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHomePageInventoryItemsQuery = { __typename?: 'Query', inventoryItems?: Array<{ __typename?: 'InventoryItemsItem', id: string, productTypeId: string, blankItemId: string, workId: number, description: string, productPageUrl?: string | null, preview?: { __typename?: 'Preview', url: string } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', quantity: number, percentOff: number }> } | null, stockStatus:
      | { __typename?: 'InStockStatus', status: string }
      | { __typename?: 'OutOfStockStatus', status: string }
      | { __typename?: 'PresaleStockStatus', status: string }
    , productPageUrls?: { __typename?: 'ProductUrl', url?: string | null, fallbackUrl: string } | null, work: { __typename?: 'Work', id: string, title: string, matureContent: boolean, artistShopDisplayName?: string | null, artistUsername: string, artist?: { __typename?: 'Artist', artistId: string } | null } } | null> | null };

export type GetSimilarDesignsInventoryItemsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  unit: Unit;
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSimilarDesignsInventoryItemsQuery = { __typename?: 'Query', inventoryItems?: Array<{ __typename?: 'InventoryItemsItem', id: string, blankItemId: string, description: string, productTypeId: string, productPageUrl?: string | null, workId: number, previewSet?: { __typename?: 'PreviewSet', previews: Array<{ __typename?: 'Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'Price', id: string, amount: number, currency: string, discount: { __typename?: 'PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
      | { __typename?: 'InStockStatus', status: string }
      | { __typename?: 'OutOfStockStatus', status: string }
      | { __typename?: 'PresaleStockStatus', status: string }
    , work: { __typename?: 'Work', id: string, url: string, title: string, matureContent: boolean, artistUsername: string, artistShopDisplayName?: string | null, portfolioPreview?: { __typename?: 'Preview', url: string } | null } } | null> | null };

export type GetSizeGuideQueryVariables = Exact<{
  inventoryItemId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
  workId: Scalars['Int']['input'];
}>;


export type GetSizeGuideQuery = { __typename?: 'Query', sizeGuide?: { __typename?: 'DimensionGuide', fixedFirstColumn: boolean, columns: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> }> }>, rows: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any, attributes: Array<{ __typename?: 'Attribute', name: string, value: any }> }> }> } | null };

export type GetProductUrlQueryVariables = Exact<{
  inventoryItemId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductUrlQuery = { __typename?: 'Query', productUrl?: { __typename?: 'ProductUrl', url?: string | null, fallbackUrl: string } | null };

export const InventoryItemFragmentDoc = gql`
    fragment InventoryItem on InventoryItemsItem {
  id
  blankItemId
  description
  work {
    id
    title
    matureContent
    tags
    id
    workId
    matureContent
    licensed
    isMachineTranslated
    productPageIndexable
    title
    description
    url
    linkBackTags
    tags
    originalLocale
    artist {
      artistId
      displayName
      username
      profileUrl
      shopUrl
      avatarUrl
      coverImageUrl
      location
      joinedDate
      followerCount
      followingCount
      analyticsCode
      established
      fanArtist
      featuredArtist
      externalSites {
        site
        label
        url
      }
    }
    portfolioPreview {
      id
      previewTypeId
      url
      mime
      formats {
        mime
        url
        fallback
      }
    }
  }
  productPageUrls {
    url
    fallbackUrl
  }
  previewSet {
    id
    previews {
      previewTypeId
      url
    }
  }
  productTypeId
  productPageUrl
  workId
  price {
    id
    amount
    currency
    discount {
      amount
      percent
    }
  }
  volumeDiscount {
    id
    thresholds {
      percentOff
      quantity
    }
  }
  stockStatus {
    status
  }
  attributes {
    name
    value
  }
}
    `;
export const SearchResultInventoryItemFragmentDoc = gql`
    fragment SearchResultInventoryItem on InventoryItemsItem {
  id
  blankItemId
  description
  measurementSummary
  work {
    id
    title
    artistShopDisplayName
    artistUsername
    matureContent
    tags
  }
  productPageUrls {
    url
    fallbackUrl
  }
  previewSet {
    id
    previews {
      previewTypeId
      url
    }
  }
  productTypeId
  productPageUrl
  workId
  price {
    id
    amount
    currency
    discount {
      amount
      percent
    }
  }
  volumeDiscount {
    id
    thresholds {
      percentOff
      quantity
    }
  }
  stockStatus {
    status
  }
  attributes {
    name
    value
    attributes {
      name
      value
    }
  }
}
    `;
export const HomePageInventoryItemFragmentDoc = gql`
    fragment HomePageInventoryItem on InventoryItemsItem {
  id
  productTypeId
  blankItemId
  workId
  description
  preview(previewTypeId: "product_close") {
    url
  }
  price {
    id
    amount
    currency
    discount {
      amount
      percent
    }
  }
  volumeDiscount {
    thresholds {
      quantity
      percentOff
    }
  }
  stockStatus {
    status
  }
  productPageUrl
  productPageUrls {
    url
    fallbackUrl
  }
  work(locale: $locale) {
    id
    title
    matureContent
    artistShopDisplayName
    artistUsername
    artist {
      artistId
    }
  }
}
    `;
export const SimilarDesignInventoryItemFragmentDoc = gql`
    fragment SimilarDesignInventoryItem on InventoryItemsItem {
  id
  blankItemId
  description
  productTypeId
  productPageUrl
  workId
  previewSet {
    previews {
      previewTypeId
      url
    }
  }
  price {
    id
    amount
    currency
    discount {
      amount
      percent
    }
  }
  volumeDiscount {
    id
    thresholds {
      percentOff
      quantity
    }
  }
  stockStatus {
    status
  }
  work(locale: $locale) {
    id
    url
    title
    matureContent
    artistUsername
    artistShopDisplayName
    portfolioPreview {
      url
    }
  }
}
    `;
export const ProductFamilyDefaultItemFragmentDoc = gql`
    fragment ProductFamilyDefaultItem on InventoryItemsItem {
  id
  productTypeId
  blankItemId
}
    `;
export const ProductFamilyItemFragmentDoc = gql`
    fragment ProductFamilyItem on InventoryItemsItem {
  id
  workId
  productTypeId
  blankItemId
  description
  measurementSummary
  attributes {
    name
    value
    attributes {
      name
      value
    }
  }
  hasSizeGuide
  price {
    id
    amount
    currency
    discount {
      amount
      percent
    }
  }
  previewSet {
    id
    inventoryItemId
    previews {
      id
      previewTypeId
      url
      mime
      formats {
        url
        mime
        fallback
      }
    }
  }
  productPageUrl
  productPageUrls {
    id
    url
    fallbackUrl
  }
  stockStatus {
    status
  }
  volumeDiscount {
    id
    thresholds {
      percentOff
      quantity
    }
  }
}
    `;
export const ProductFamilyWorkFragmentDoc = gql`
    fragment ProductFamilyWork on Work {
  id
  workId
  matureContent
  licensed
  isMachineTranslated
  productPageIndexable
  artistUsername
  artistDisplayName
  artistShopDisplayName
  artist {
    artistId
    displayName
    username
    avatarUrl
    profileUrl
    established
    featuredArtist
    fanArtist
    externalSites {
      label
      site
      url
    }
  }
  title
  description
  url
  linkBackTags
  tags
  tagsCleaned
  tagsOriginal
  originalLocale
  remoteKey
  portfolioPreview {
    id
    previewTypeId
    url
    mime
    formats {
      mime
      url
      fallback
    }
  }
}
    `;
export const GetCategorySetDocument = gql`
    query GetCategorySet($workId: Int!, $categoryId: String!, $groupId: String, $country: String!, $currency: String!, $locale: String!, $previewTypeIds: [String!]!, $unit: Unit!) {
  categorySet(
    workId: $workId
    categoryId: $categoryId
    locale: $locale
    country: $country
    currency: $currency
    previewTypeIds: $previewTypeIds
    unit: $unit
    groupId: $groupId
  ) {
    id
    defaultItem {
      id
    }
    work {
      id
      artistUsername
    }
  }
}
    `;
export const GetProductFamilyDocument = gql`
    query GetProductFamily($workId: Int!, $productFamilyIdOrProductTypeId: String!, $country: String!, $currency: String!, $locale: String!, $previewTypeIds: [String!]!, $unit: Unit!, $groupId: String) {
  productFamily(
    workId: $workId
    productFamilyIdOrProductTypeId: $productFamilyIdOrProductTypeId
    country: $country
    currency: $currency
    locale: $locale
    previewTypeIds: $previewTypeIds
    unit: $unit
    groupId: $groupId
  ) {
    id
    categoryName
    configurationSet {
      name
      value
      attributes {
        name
        value
      }
    }
    defaultItem {
      ...ProductFamilyDefaultItem
    }
    defaultItems {
      ...ProductFamilyDefaultItem
    }
    items {
      ...ProductFamilyItem
    }
    work(locale: $locale) {
      ...ProductFamilyWork
    }
  }
}
    ${ProductFamilyDefaultItemFragmentDoc}
${ProductFamilyItemFragmentDoc}
${ProductFamilyWorkFragmentDoc}`;
export const GetInventoryItemsDocument = gql`
    query GetInventoryItems($ids: [ID!]!, $locale: String!, $previewTypeIds: [String!], $country: String, $currency: String, $unit: Unit!, $groupId: String) {
  inventoryItems(
    ids: $ids
    locale: $locale
    previewTypeIds: $previewTypeIds
    country: $country
    currency: $currency
    unit: $unit
    groupId: $groupId
  ) {
    ...InventoryItem
  }
}
    ${InventoryItemFragmentDoc}`;
export const GetDefaultInventoryItemsDocument = gql`
    query GetDefaultInventoryItems($workId: Int!, $locale: String!, $productTypeIds: [String!], $previewTypeIds: [String!], $country: String, $currency: String, $unit: Unit!, $groupId: String) {
  defaultInventoryItems(
    workId: $workId
    locale: $locale
    productTypeIds: $productTypeIds
    previewTypeIds: $previewTypeIds
    country: $country
    currency: $currency
    unit: $unit
    groupId: $groupId
  ) {
    ...InventoryItem
  }
}
    ${InventoryItemFragmentDoc}`;
export const GetSearchResultInventoryItemsDocument = gql`
    query GetSearchResultInventoryItems($ids: [ID!]!, $locale: String!, $previewTypeIds: [String!], $country: String, $currency: String, $unit: Unit!, $groupId: String) {
  inventoryItems(
    ids: $ids
    locale: $locale
    previewTypeIds: $previewTypeIds
    country: $country
    currency: $currency
    unit: $unit
    groupId: $groupId
  ) {
    ...SearchResultInventoryItem
  }
}
    ${SearchResultInventoryItemFragmentDoc}`;
export const GetHomePageInventoryItemsDocument = gql`
    query GetHomePageInventoryItems($ids: [ID!]!, $locale: String!, $previewTypeIds: [String!], $country: String, $currency: String, $unit: Unit!, $groupId: String) {
  inventoryItems(
    ids: $ids
    locale: $locale
    previewTypeIds: $previewTypeIds
    country: $country
    currency: $currency
    unit: $unit
    groupId: $groupId
  ) {
    ...HomePageInventoryItem
  }
}
    ${HomePageInventoryItemFragmentDoc}`;
export const GetSimilarDesignsInventoryItemsDocument = gql`
    query GetSimilarDesignsInventoryItems($ids: [ID!]!, $locale: String!, $previewTypeIds: [String!], $country: String, $currency: String, $unit: Unit!, $groupId: String) {
  inventoryItems(
    ids: $ids
    locale: $locale
    previewTypeIds: $previewTypeIds
    country: $country
    currency: $currency
    unit: $unit
    groupId: $groupId
  ) {
    ...SimilarDesignInventoryItem
  }
}
    ${SimilarDesignInventoryItemFragmentDoc}`;
export const GetSizeGuideDocument = gql`
    query GetSizeGuide($inventoryItemId: String, $locale: String!, $productTypeId: String!, $workId: Int!) {
  sizeGuide(
    inventoryItemId: $inventoryItemId
    locale: $locale
    productTypeId: $productTypeId
    workId: $workId
  ) {
    fixedFirstColumn
    columns {
      name
      value
      attributes {
        name
        value
        attributes {
          name
          value
        }
      }
    }
    rows {
      name
      value
      attributes {
        name
        value
        attributes {
          name
          value
        }
      }
    }
  }
}
    `;
export const GetProductUrlDocument = gql`
    query GetProductUrl($inventoryItemId: ID!, $locale: String!, $groupId: String) {
  productUrl(
    inventoryItemId: $inventoryItemId
    locale: $locale
    groupId: $groupId
  ) {
    url
    fallbackUrl
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetCategorySet(variables: GetCategorySetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetCategorySetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCategorySetQuery>({ document: GetCategorySetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetCategorySet', 'query', variables);
    },
    GetProductFamily(variables: GetProductFamilyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProductFamilyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductFamilyQuery>({ document: GetProductFamilyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetProductFamily', 'query', variables);
    },
    GetInventoryItems(variables: GetInventoryItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetInventoryItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInventoryItemsQuery>({ document: GetInventoryItemsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetInventoryItems', 'query', variables);
    },
    GetDefaultInventoryItems(variables: GetDefaultInventoryItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDefaultInventoryItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDefaultInventoryItemsQuery>({ document: GetDefaultInventoryItemsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetDefaultInventoryItems', 'query', variables);
    },
    GetSearchResultInventoryItems(variables: GetSearchResultInventoryItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSearchResultInventoryItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSearchResultInventoryItemsQuery>({ document: GetSearchResultInventoryItemsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetSearchResultInventoryItems', 'query', variables);
    },
    GetHomePageInventoryItems(variables: GetHomePageInventoryItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetHomePageInventoryItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHomePageInventoryItemsQuery>({ document: GetHomePageInventoryItemsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetHomePageInventoryItems', 'query', variables);
    },
    GetSimilarDesignsInventoryItems(variables: GetSimilarDesignsInventoryItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSimilarDesignsInventoryItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSimilarDesignsInventoryItemsQuery>({ document: GetSimilarDesignsInventoryItemsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetSimilarDesignsInventoryItems', 'query', variables);
    },
    GetSizeGuide(variables: GetSizeGuideQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSizeGuideQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSizeGuideQuery>({ document: GetSizeGuideDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetSizeGuide', 'query', variables);
    },
    GetProductUrl(variables: GetProductUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProductUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductUrlQuery>({ document: GetProductUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetProductUrl', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;